import { createFileRoute, Outlet } from '@tanstack/react-router';

import { CenteredLayout } from '../../ui/components/layout';
import { hideHtmlLoader } from '../../ui/utils/html';

export const Route = createFileRoute('/auth')({
  component: () => (
    <CenteredLayout>
      <Outlet />
    </CenteredLayout>
  ),
  beforeLoad: () => {
    hideHtmlLoader();
  },
});
